import React, { useRef } from 'react'
import cx from 'classnames'
import styles from '../../styles/HistoryPage.module.css'
import Head from 'next/head'
import BreadcrumbScroll from '../../components/Elements/BreadcrumbScroll/BreadcrumbScroll'
import Image from 'next/image'
import { useInView } from 'framer-motion'
import YearHistory from '../../components/Elements/YearHistory/YearHistory'
import { historyDateList } from '../../components/Data/historyDate'
import StaticTopics from '../../components/Elements/StaticTopics/StaticTopics'

const HistoryPage = () => {
  const refMainTitle = useRef()
  const isMainTitleInView = useInView(refMainTitle)

  const refLastRow = useRef()
  const isLastRowInView = useInView(refLastRow)

  return (
    <>
      <Head>
        <title>تاریخچه ما - درباره گروه دیجی‌کالا</title>
        <meta
          name='viewport'
          content='initial-scale=1.0, width=device-width, maximum-scale=1'
        />
        <meta charSet='utf-8' />
        <meta
          name='description'
          content='از سال 1385 با فروش آنلاین محصولات الکترونیک و دیجیتال شروع به کار کردیم اما بعد از تغییر به مدل مارکت‌پِلیس از سال 1395 به مرحله‌ای جدید، عجیب و البته پر از'
        />
        <link rel='icon' type='image/x-icon' href='/faviconNew.svg'></link>
        <meta
          name='robots'
          content='index, follow, max-snippet:-1, max-video-preview:-1, max-image-preview:large'
        />
        <link rel='canonical' href={`https://about.digikala.com/history/`} />
        <meta property='og:locale' content='fa_IR' />
        <meta property='og:type' content='website' />
        <meta
          property='og:title'
          content='تاریخچه ما - درباره گروه دیجی‌کالا'
        />
        <meta
          property='og:url'
          content={`https://about.digikala.com/history/`}
        />
        <meta property='og:site_name' content='درباره گروه دیجی‌کالا' />
        <meta property='og:image' itemProp='image' content='/ogImage.jpg' />
        <meta property='og:image:width' content='500' />
        <meta property='og:image:height' content='500' />
        <meta
          property='og:image:alt'
          content='تاریخچه ما - درباره گروه دیجی‌کالا'
        />
        <meta property='og:image:type' content='image/png' />
        <meta
          property='og:site_name'
          content='تاریخچه ما - درباره گروه دیجی‌کالا'
          key='ogsitename'
        />
        <meta
          property='og:title'
          content='تاریخچه ما - درباره گروه دیجی‌کالا'
          key='ogtitle'
        />
        <meta
          property='og:description'
          content='از سال 1385 با فروش آنلاین محصولات الکترونیک و دیجیتال شروع به کار کردیم اما بعد از تغییر به مدل مارکت‌پِلیس از سال 1395 به مرحله‌ای جدید، عجیب و البته پر از'
          key='ogdesc'
        />
        <meta name='twitter:card' content='summary_large_image' />
        <meta
          name='twitter:title'
          content='تاریخچه ما - درباره گروه دیجی‌کالا'
        />
        <meta name='twitter:site' content='درباره گروه دیجی‌کالا' />
        <meta
          name='twitter:image'
          content='https://about.digikala.com/ogImage.jpg'
        />
        <meta
          name='twitter:description'
          content='از سال 1385 با فروش آنلاین محصولات الکترونیک و دیجیتال شروع به کار کردیم اما بعد از تغییر به مدل مارکت‌پِلیس از سال 1395 به مرحله‌ای جدید، عجیب و البته پر از'
        />
      </Head>
      <BreadcrumbScroll
        title='تاریخچه ما'
        routeOne='/history'
        titleOne='تاریخچه ما'
      />
      <div className='breadCrumbSpacer'></div>
      <div className={cx(styles.headerImageWrapper)}>
        <Image
          src='https://about.digikala.com/wp-content/uploads/2022/02/header-overview-2-1-1024x479.jpg'
          alt='تاریخچه ما'
          unoptimized
          width={100}
          height={100}
        />
      </div>
      <h1
        style={{
          transform: isMainTitleInView ? 'none' : 'translateY(-100px)',
          opacity: isMainTitleInView ? 1 : 0,
          transition: 'all ease 1400ms'
        }}
        className='hOneStaticTitles text-center w-100 my-5'
      >
        دیجی‌کالا از گذشته تا امروز
      </h1>
      <div ref={refMainTitle}></div>
      <div className='container mb-5'>
        <p className='paragraphStaticPages text-center'>
          از سال ۱۳۸۵ با فروش آنلاین محصولات الکترونیک و دیجیتال شروع به کار
          کردیم اما بعد از تغییر به مدل مارکت‌پِلیس از سال ۱۳۹۵ به مرحله‌ای
          جدید، عجیب و البته پر از یادگیری و مسئولیت وارد شدیم. آنچه که حالا به
          عنوان گروه دیجی‌کالا شناخته می‌شود زنجیره گسترده‌ای از خرید و فروش
          آنلاین تمامی کالا‌ها با تنوع بسیار بالاست و نیز در برگیرنده پلتفرم‌ها
          و سرویس‌های مختلف است که هر کدام در مسیر خلق ارزش در اقتصاد دیجیتال
          ایران گام بر‌می‌دارند. تاریخچه گروه دیجی‌کالا داستانی دارد که ما برای
          شما تعریف می‌کنیم.
        </p>
      </div>
      {historyDateList.map((item, index, arr) => (
        <div key={index} className='w-100'>
          <YearHistory
            shamsiDate={item.shamsiDate}
            miladiDate={item.miladiDate}
            yearItems={item.items}
            reverse={index % 2 !== 0}
            isLast={arr.length - 1 === index}
          />
        </div>
      ))}
      <div className='container my-5 py-5'>
        <StaticTopics
          title='مارکت پلیس دیجی‌کالا وارد ششمین سال فعالیت خود شد'
          paragraph='پلتفرم مارکت پلیس دیجی‌کالا پس از پنج سال فعالیت و رشد روز افزون حالا وارد ششمین سال فعالیت خود شده است. اکنون دیجی‌کالا به خانه تمامی کسب‌وکارهای ایرانی تبدیل شده است.
مارکت‌پِلِیس دیجی‌کالا بستری است که امکان خرید از چند ده هزار تأمین‌کننده متفاوت را برای مشتریان فراهم می‌کند. در مارکت‌پِلِیس دیجی‌کالا بیش‌از ۱۶۰ هزار فروشنده برای عرضه محصولات خود به بازار ۸۰ میلیون نفری ایران گرد هم آمده‌اند و خریداران می‌توانند با بررسی محصولات آنها آنچه را که نیاز دارند تهیه کنند.'
          isInView={isLastRowInView}
          divRef={refLastRow}
          imgaSrc='https://about.digikala.com/wp-content/uploads/2022/02/6th-anniversary.jpg'
          link='https://www.digikala.com/mag/video/6th-anniversary-marketplace-digikala/'
          linkTitle='راهنمای هویت بصری دیجی‌کالا'
        />
      </div>
    </>
  )
}

export default HistoryPage
